import { api, getAuthHeader } from './help';

export const getToMsg = async (data) => {
  const response = await api.post('/notification/to', data, getAuthHeader());
  return response.data;
};

export const getToMsgDetail = async (requestId) => {
  const response = await api.get(`/notification/to/detail/${requestId}`, getAuthHeader());
  return response.data;
};

export const getFromMsg = async (data) => {
  const response = await api.post('/notification/from', data, getAuthHeader());
  return response.data;
};

export const getFromMsgDetail = async (requestId) => {
  const response = await api.get(`/notification/from/detail/${requestId}`, getAuthHeader());
  return response.data;
};

export const acceptRequest = async (data) => {
  const response = await api.post('/notification/accept', { id: data.id }, getAuthHeader());
  return response.data;
};

export const declineRequest = async (data) => {
  const response = await api.post('/notification/decline', data, getAuthHeader());
  return response.data;
};

export const deleteRequest = async (data) => {
  const response = await api.delete('/notification?id=' + data, getAuthHeader());
  return response.data;
};

export const setNotificationActivity = async () => {
  const response = await api.get('/notification/activity', getAuthHeader());
  return response.data;
};
